import { USER_TYPE } from "../../configs/constants";
import { changeStyle, formatDate } from "../../utils/format";
import {
  Box,
  SpaceBetween,
  Header,
  ColumnLayout,
  Container,
  TextContent,
  Grid,
} from "@cloudscape-design/components-themed";
// import { useNavigate } from "react-router-dom";
import { LABELS } from "./constants";
import { useCanIShowHook } from "../../app/useCanIShowHook";
import { useGetReferenceGroupNamesQuery } from "../../features/api";
import { COMMON_LABELS } from "../default-constants";

export const ApplicationTab = (props: any) => {
  // ユーザ権限
  const isDocomoUser = useCanIShowHook(USER_TYPE.DOCOMO);
  const isGWUser = useCanIShowHook(USER_TYPE.GW);
  // const navigate = useNavigate();
  const { data: dataList } = useGetReferenceGroupNamesQuery(
    {
      applyCompanyId: props.groupData,
      companyType: props.companyType,
    },
    {
      skip: !props.groupData || !props.companyType,
    }
  );

  return (
    <SpaceBetween direction="vertical" size="l">
      {props.corpInfo.changedFlag ? (
        <>
          <Box float="left"></Box>
          <Box float="right">
            <SpaceBetween direction="horizontal" size="xxl">
              <TextContent>
                <h4>{LABELS.CHANGED_APP}</h4>
              </TextContent>
              {props.corpInfo.orderAdaptationDate !== null ? (
                <>
                  <TextContent>
                    <h4>
                      {COMMON_LABELS.LEFT_PARENTHESIS + LABELS.ADAPTED_DAY}
                    </h4>
                  </TextContent>
                  <TextContent>
                    <p>
                      {formatDate(props.corpInfo.orderAdaptationDate) +
                        COMMON_LABELS.RIGHT_PARENTHESIS}
                    </p>
                  </TextContent>
                </>
              ) : null}
            </SpaceBetween>
          </Box>
        </>
      ) : (
        <></>
      )}
      <Container
        header={<Header variant="h2">{LABELS.APPLICATION_INFO_TITLE}</Header>}
      >
        <SpaceBetween direction="horizontal" size="l">
          <ColumnLayout columns={1}>
            <SpaceBetween direction="horizontal" size="xxl">
              <ColumnLayout columns={2}>
                <SpaceBetween direction="vertical" size="xxs">
                  <TextContent>
                    <h4>{LABELS.CORP_NUMBER}</h4>
                  </TextContent>
                  <TextContent>
                    <h4>{LABELS.COMPANY_STYLE}</h4>
                  </TextContent>
                </SpaceBetween>
              </ColumnLayout>
              <SpaceBetween direction="vertical" size="xxxs">
                <TextContent>
                  <p>{props.corpInfo.corporateNumber || "　"}</p>
                </TextContent>
                <TextContent>
                  <p>
                    {props.corpInfo.businessStyle === 1 ? "法人" : "個人事業主"}
                  </p>
                </TextContent>
              </SpaceBetween>
            </SpaceBetween>
          </ColumnLayout>
          <ColumnLayout columns={2}>
            <SpaceBetween direction="vertical" size="xxs">
              {isDocomoUser ? (
                <TextContent>
                  <h4>{LABELS.DUN_NUMBER}</h4>
                </TextContent>
              ) : (
                <></>
              )}
              {isDocomoUser ? (
                <TextContent>
                  <h4>{LABELS.COMPANY_TYPE}</h4>
                </TextContent>
              ) : (
                <></>
              )}
            </SpaceBetween>
          </ColumnLayout>
          <SpaceBetween direction="vertical" size="xxxs">
            {isDocomoUser ? (
              <TextContent>
                <p>{props.corpInfo.dunsNumber ?? "　"}</p>
              </TextContent>
            ) : (
              <></>
            )}
            {isDocomoUser ? (
              <TextContent>
                <p>{props.corpInfo.tradeNameLegalPersonality ?? "　"}</p>
              </TextContent>
            ) : (
              <></>
            )}
          </SpaceBetween>
        </SpaceBetween>
        <SpaceBetween direction="vertical" size="xxs">
          <Grid gridDefinition={[{ colspan: 2 }, { colspan: 10 }]}>
            <SpaceBetween direction="vertical" size="xxs">
              <TextContent>
                <h4>{LABELS.CORP_NAME}</h4>
              </TextContent>
            </SpaceBetween>
            <SpaceBetween direction="vertical" size="xxs">
              <TextContent>
                <p>
                  {(props.corpInfo.companyNameKana ?? "　") +
                    "　/　" +
                    (props.corpInfo.companyNameAlphabetical ?? "　")}
                </p>
              </TextContent>
            </SpaceBetween>
          </Grid>
          <Grid gridDefinition={[{ colspan: 2 }, { colspan: 10 }]}>
            <SpaceBetween direction="vertical" size="xxs">
              <TextContent>
                <h4>{"　"}</h4>
              </TextContent>
            </SpaceBetween>
            <SpaceBetween direction="vertical" size="xxs">
              <TextContent>
                <p>{props.corpInfo.companyName ?? "　"}</p>
              </TextContent>
            </SpaceBetween>
          </Grid>
          <Grid gridDefinition={[{ colspan: 2 }, { colspan: 10 }]}>
            <SpaceBetween direction="vertical" size="xxs">
              <TextContent>
                <h4>{LABELS.CORP_NAME_DETAIL}</h4>
              </TextContent>
            </SpaceBetween>
            <SpaceBetween direction="vertical" size="xxs">
              <TextContent>
                <p>
                  {props.corpInfo.nameItemScreenDisplay
                    ? props.corpInfo.nameItemScreenDisplay.join("　/　")
                    : "　"}
                </p>
              </TextContent>
            </SpaceBetween>
          </Grid>
          {isGWUser ? (
            <></>
          ) : (
            <Grid gridDefinition={[{ colspan: 2 }, { colspan: 10 }]}>
              <SpaceBetween direction="vertical" size="xxs">
                <TextContent>
                  <h4>{LABELS.ADDRESS}</h4>
                </TextContent>
              </SpaceBetween>
              <SpaceBetween direction="vertical" size="xxs">
                <TextContent>
                  <p>
                    {props.corpInfo.postalCode
                      ? changeStyle(props.corpInfo.postalCode ?? "")
                      : LABELS.BLANK_SPACE_ONE}
                  </p>
                </TextContent>
              </SpaceBetween>
            </Grid>
          )}
          {isGWUser ? (
            <></>
          ) : (
            <Grid gridDefinition={[{ colspan: 2 }, { colspan: 10 }]}>
              <SpaceBetween direction="vertical" size="xxs">
                <TextContent>
                  <h4>{"　"}</h4>
                </TextContent>
              </SpaceBetween>
              <SpaceBetween direction="vertical" size="xxs">
                <TextContent>
                  <p>{props.corpInfo.addressKana ?? "　"}</p>
                </TextContent>
              </SpaceBetween>
            </Grid>
          )}
          {isGWUser ? (
            <></>
          ) : (
            <Grid gridDefinition={[{ colspan: 2 }, { colspan: 10 }]}>
              <SpaceBetween direction="vertical" size="xxs">
                <TextContent>
                  <h4>{"　"}</h4>
                </TextContent>
              </SpaceBetween>
              <SpaceBetween direction="vertical" size="xxs">
                <TextContent>
                  <p>
                    {(props.corpInfo.address1 ?? LABELS.BLANK_SPACE_ONE) +
                      (props.corpInfo.address2 ?? LABELS.BLANK_SPACE_ONE)}
                  </p>
                </TextContent>
              </SpaceBetween>
            </Grid>
          )}
          {isGWUser ? (
            <></>
          ) : (
            <Grid gridDefinition={[{ colspan: 2 }, { colspan: 10 }]}>
              <SpaceBetween direction="vertical" size="xxs">
                <TextContent>
                  <h4>{LABELS.URL}</h4>
                </TextContent>
              </SpaceBetween>
              <SpaceBetween direction="vertical" size="xxs">
                <TextContent>
                  <p>{props.corpInfo.companyUrl ?? "　"}</p>
                </TextContent>
              </SpaceBetween>
            </Grid>
          )}
          {isGWUser ? (
            <></>
          ) : (
            <Grid gridDefinition={[{ colspan: 2 }, { colspan: 10 }]}>
              <SpaceBetween direction="vertical" size="xxs">
                <TextContent>
                  <h4>{LABELS.HEAD_OFFICE_TEL}</h4>
                </TextContent>
              </SpaceBetween>
              <SpaceBetween direction="vertical" size="xxs">
                <TextContent>
                  <p>{props.corpInfo.phoneNumber ?? "　"}</p>
                </TextContent>
              </SpaceBetween>
            </Grid>
          )}
          {isDocomoUser ? (
            <Grid gridDefinition={[{ colspan: 2 }, { colspan: 10 }]}>
              <SpaceBetween direction="vertical" size="xxs">
                <TextContent>
                  <h4>{LABELS.FOUNDATION_DATE}</h4>
                </TextContent>
              </SpaceBetween>
              <SpaceBetween direction="vertical" size="xxs">
                <TextContent>
                  <p>{props.corpInfo.establishmentYearMonth ?? "　"}</p>
                </TextContent>
              </SpaceBetween>
            </Grid>
          ) : (
            <></>
          )}
          {isDocomoUser ? (
            <Grid gridDefinition={[{ colspan: 2 }, { colspan: 10 }]}>
              <SpaceBetween direction="vertical" size="xxs">
                <TextContent>
                  <h4>{LABELS.CAPITAL}</h4>
                </TextContent>
              </SpaceBetween>
              <SpaceBetween direction="vertical" size="xxs">
                <TextContent>
                  <p>
                    {(props.corpInfo.capital ?? "　") +
                      "　億円" +
                      COMMON_LABELS.LEFT_PARENTHESIS +
                      (props.corpInfo.surveyDate ?? "　") +
                      "時点" +
                      COMMON_LABELS.RIGHT_PARENTHESIS}
                  </p>
                </TextContent>
              </SpaceBetween>
            </Grid>
          ) : (
            <></>
          )}
          {isDocomoUser ? (
            <Grid gridDefinition={[{ colspan: 2 }, { colspan: 10 }]}>
              <SpaceBetween direction="vertical" size="xxs">
                <TextContent>
                  <h4>{LABELS.EMPLOYEE_NUMBER}</h4>
                </TextContent>
              </SpaceBetween>
              <SpaceBetween direction="vertical" size="xxs">
                <TextContent>
                  <p>
                    {(props.corpInfo.employeeNumber ?? "　") +
                      " 名　" +
                      COMMON_LABELS.LEFT_PARENTHESIS +
                      (props.corpInfo.surveyDate ?? "　") +
                      "時点" +
                      COMMON_LABELS.RIGHT_PARENTHESIS}
                  </p>
                </TextContent>
              </SpaceBetween>
            </Grid>
          ) : (
            <></>
          )}
        </SpaceBetween>
      </Container>

      <Container header={<Header variant="h2">{LABELS.REP_INFO_TITLE}</Header>}>
        <SpaceBetween direction="vertical" size="xxs">
          {isGWUser ? (
            <></>
          ) : (
            <Grid gridDefinition={[{ colspan: 2 }, { colspan: 10 }]}>
              <SpaceBetween direction="vertical" size="xxs">
                <TextContent>
                  <h4>{LABELS.REP_NAME}</h4>
                </TextContent>
              </SpaceBetween>
              <SpaceBetween direction="vertical" size="xxs">
                <TextContent>
                  <p>
                    {(props.corpInfo.repNameKana ?? "　") +
                      "　/　" +
                      (props.corpInfo.repNameAlphabetical ?? "　")}
                  </p>
                </TextContent>
              </SpaceBetween>
            </Grid>
          )}
          {isGWUser ? (
            <></>
          ) : (
            <Grid gridDefinition={[{ colspan: 2 }, { colspan: 10 }]}>
              <SpaceBetween direction="vertical" size="xxs">
                <TextContent>
                  <h4>{"　"}</h4>
                </TextContent>
              </SpaceBetween>
              <SpaceBetween direction="vertical" size="xxs">
                <TextContent>
                  <p>{props.corpInfo.repName ?? "　"}</p>
                </TextContent>
              </SpaceBetween>
            </Grid>
          )}
          {isGWUser ? (
            <></>
          ) : (
            <Grid gridDefinition={[{ colspan: 2 }, { colspan: 10 }]}>
              <SpaceBetween direction="vertical" size="xxs">
                <TextContent>
                  <h4>{LABELS.BIRTHDAY}</h4>
                </TextContent>
              </SpaceBetween>
              <SpaceBetween direction="vertical" size="xxs">
                <TextContent>
                  <p>{formatDate(props.corpInfo.repBirthdate ?? "　")}</p>
                </TextContent>
              </SpaceBetween>
            </Grid>
          )}
          {isDocomoUser ? (
            <Grid gridDefinition={[{ colspan: 2 }, { colspan: 10 }]}>
              <SpaceBetween direction="vertical" size="xxs">
                <TextContent>
                  <h4>{LABELS.COUNTRY}</h4>
                </TextContent>
              </SpaceBetween>
              <SpaceBetween direction="vertical" size="xxs">
                <TextContent>
                  <p>{props.corpInfo.repCountry ?? "　"}</p>
                </TextContent>
              </SpaceBetween>
            </Grid>
          ) : (
            <></>
          )}
        </SpaceBetween>
      </Container>
      {dataList ? (
        <Container
          header={<Header variant="h2">{LABELS.GROUP_TABLE_TITLE}</Header>}
        >
          {dataList.map((item: any) => (
            <SpaceBetween
              direction="horizontal"
              size="l"
              key={item.referenceGroupId}
            >
              <ColumnLayout columns={1}>
                <SpaceBetween direction="vertical" size="xxs">
                  <TextContent>
                    <h4>{LABELS.GROUP_NAME}</h4>
                  </TextContent>
                </SpaceBetween>
              </ColumnLayout>
              <SpaceBetween direction="horizontal" size="xxxs">
                <TextContent>
                  <p>{item.referenceGroupName}</p>
                </TextContent>
              </SpaceBetween>
            </SpaceBetween>
          ))}
        </Container>
      ) : (
        <></>
      )}

      {isDocomoUser ? (
        <Container
          header={<Header variant="h2">{LABELS.TSR_INFO_TITLE}</Header>}
        >
          <SpaceBetween direction="horizontal" size="l">
            <ColumnLayout columns={1}>
              <SpaceBetween direction="horizontal" size="xxl">
                <ColumnLayout columns={2}>
                  <SpaceBetween direction="horizontal" size="xxl">
                    <SpaceBetween direction="vertical" size="xxs">
                      <TextContent>
                        <h4>{LABELS.COMPANY_SITUATION}</h4>
                      </TextContent>
                    </SpaceBetween>
                    <SpaceBetween direction="vertical" size="xxxs">
                      <TextContent>
                        <p>{props.corpInfo.companySituationName ?? "　"}</p>
                      </TextContent>
                    </SpaceBetween>
                  </SpaceBetween>
                </ColumnLayout>
                <ColumnLayout columns={2}>
                  <SpaceBetween direction="horizontal" size="xxl">
                    <SpaceBetween direction="vertical" size="xxs">
                      <TextContent>
                        <h4>{LABELS.POINT}</h4>
                      </TextContent>
                    </SpaceBetween>
                    <SpaceBetween direction="vertical" size="xxxs">
                      <TextContent>
                        <p>{props.corpInfo.score ?? "　"}</p>
                      </TextContent>
                    </SpaceBetween>
                  </SpaceBetween>
                </ColumnLayout>
              </SpaceBetween>
            </ColumnLayout>
          </SpaceBetween>
        </Container>
      ) : (
        <></>
      )}
      {/* step1　不要 */}
      {/* {isDocomoUser ? (
        <ColumnLayout columns={2}>
          <Box float="left"></Box>
          <Box float="right">
            <SpaceBetween direction="horizontal" size="xxl">
              <Button
                variant="normal"
                iconAlign="right"
                onClick={() => {
                  navigate(
                    `/merchant/direct-application/corporate-info/${props.corpInfo.companyCode}`
                  );
                }}
              >
                {LABELS.INFORMATION_CHANGE}
              </Button>
            </SpaceBetween>
          </Box>
        </ColumnLayout>
      ) : (
        <></>
      )} */}
    </SpaceBetween>
  );
};

export default ApplicationTab;
